import { UXState, PERSONA_PRESETS } from './types'

const STORAGE_KEY = 'portfolio-ux-state'

export function parseQueryParams(): Partial<UXState> {
  const params = new URLSearchParams(window.location.search)
  const state: Partial<UXState> = {}

  // Parse ?view=recruiter|engineer
  const view = params.get('view')
  if (view === 'recruiter' || view === 'engineer') {
    state.persona = view
  }

  // Parse ?theme=light|dark|system
  const theme = params.get('theme')
  if (theme === 'light' || theme === 'dark' || theme === 'system') {
    state.theme = theme
  }

  // Parse ?lang=en|fr
  const lang = params.get('lang')
  if (lang === 'en' || lang === 'fr') {
    state.locale = lang
  }

  // Parse ?demo=1
  if (params.get('demo') === '1') {
    state.demo = true
  }

  // Parse axes: ?density=0.5&depth=0.8&motion=0.2
  const density = params.get('density')
  const depth = params.get('depth')
  const motion = params.get('motion')

  if (density || depth || motion) {
    state.axes = {
      density: density ? parseFloat(density) : PERSONA_PRESETS.recruiter.density,
      depth: depth ? parseFloat(depth) : PERSONA_PRESETS.recruiter.depth,
      motion: motion ? parseFloat(motion) : PERSONA_PRESETS.recruiter.motion,
    }
  }

  return state
}

export function loadFromLocalStorage(): Partial<UXState> {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      return JSON.parse(stored)
    }
  } catch (e) {
    console.warn('Failed to load UX state from localStorage', e)
  }
  return {}
}

export function saveToLocalStorage(state: UXState) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch (e) {
    console.warn('Failed to save UX state to localStorage', e)
  }
}

export function updateQueryParams(state: UXState) {
  const params = new URLSearchParams()

  if (state.persona !== 'recruiter') {
    params.set('view', state.persona)
  }

  // Only add theme if not 'system' (default)
  if (state.theme !== 'system') {
    params.set('theme', state.theme)
  }

  // Only add locale if not 'en' (default)
  if (state.locale !== 'en') {
    params.set('lang', state.locale)
  }

  if (state.demo) {
    params.set('demo', '1')
  }

  // Only add axes if custom (not matching preset)
  const preset = PERSONA_PRESETS[state.persona]
  if (
    state.axes.density !== preset.density ||
    state.axes.depth !== preset.depth ||
    state.axes.motion !== preset.motion
  ) {
    params.set('density', state.axes.density.toFixed(2))
    params.set('depth', state.axes.depth.toFixed(2))
    params.set('motion', state.axes.motion.toFixed(2))
  }

  const newUrl = params.toString() ? `?${params.toString()}` : window.location.pathname
  window.history.replaceState({}, '', newUrl)
}
